import { cn } from "@/lib/utils";
import { FLOW_COLOR, type FlowColorKey } from "./flowColors";
import { ModeIcon, type FlowModeKey } from "./ModeIcon";
type FlowLegendKey = FlowColorKey;
export function FlowLegend({
  items,
  modes = [],
  className
}: {
  items: {
    key: FlowLegendKey;
    label: string;
  }[];
  modes?: {
    mode: FlowModeKey;
    label: string;
  }[];
  className?: string;
}) {
  return <div className={cn("flex flex-wrap items-center text-ink-2", className)} style={{
    columnGap: 16,
    rowGap: 6,
    fontSize: 12
  }} data-sentry-component="FlowLegend" data-sentry-source-file="FlowLegend.tsx">
            {items.map(item => <span key={item.key} className="flex items-center whitespace-nowrap" style={{
      gap: 6
    }}>
                    <span className="shrink-0 rounded-full" style={{
        width: 7,
        height: 7,
        background: FLOW_COLOR[item.key]
      }} />
                    {item.label}
                </span>)}
            {modes.length > 0 && <span className="shrink-0" style={{
      width: 1,
      height: 14,
      background: "rgb(var(--ink) / 0.14)"
    }} />}
            {modes.map(item => <span key={item.mode} className="flex items-center whitespace-nowrap" style={{
      gap: 6
    }}>
                    <span style={{
        color: "rgb(var(--ink) / 0.5)"
      }}>
                        <ModeIcon mode={item.mode} />
                    </span>
                    {item.label}
                </span>)}
        </div>;
}